import React, { Fragment } from 'react';
import Moment from 'react-moment';
import { useQuery } from '@apollo/client';
import { LAUNCH_QUERY } from '../lib/queries';
import LogoSpaceX from '../assets/LogoSpaceX.png';
import RocketItem from "./RocketItem";
import RocketKey from './RocketKey';
import ImageSlider from "./ImageSlider";
import { useParams } from "react-router";
import { Link } from 'react-router-dom';

import classNames from 'classnames';

export default function Launch() {
    
    const { id: launchId } = useParams();
    
    const { loading, error, data } = useQuery(LAUNCH_QUERY, {
        variables: { launchId },
    });
    // console.log(data);
    
    if (loading) return (
        <Fragment>
            <div className="spinner-grow spinner-grow-sm"></div>
            <div className="spinner-grow spinner-grow-sm"></div>
            <div className="spinner-grow spinner-grow-sm"></div>
            <div className="spinner-grow spinner-grow-sm"></div>
        </Fragment>
    );
    
    if (error) return `Error! ${error.message}`;
    
    // Here request => launch details
    const {
        // eslint-disable-next-line
        launchpad,
        flight_number,
        name,
        // eslint-disable-next-line
        date_utc,
        date_local,
        success,
        // eslint-disable-next-line
        details,
        // eslint-disable-next-line
        links: { presskit, patch: { small, large }, webcast, article, wikipedia },
        rocket,
    } = data.launch;
    // console.log("Target ID ====> ", rocket);

    // Here request => rockets details
    const {
        // eslint-disable-next-line
        id,
        // eslint-disable-next-line
        type,
        // eslint-disable-next-line
        country,
        // eslint-disable-next-line
        first_flight,
        // eslint-disable-next-line
        flickr_images
    } = data.rockets;

    // const arrayToObject = Object.assign({}, ...data.rockets);
    // console.log(Object.assign({}, ...data.rockets));
    // console.log(data.rockets.filter(value => value.id === `${rocket}`))
    const rocketId = data.rockets.filter(value => value.id === `${rocket}`)
    // console.log(rocketId);
    const objectRocket = Object.assign({},...rocketId);
    // console.log("Object find with target ID =====> ", objectRocket);

    return (
        
        <Fragment>
            <div>
                <div className="mb-3" style={{ display: 'flex', flexDirection: 'row', alignContent: 'flex-end', alignItems: 'flex-end' }}>
                    <h1 className="display-4 my-3">
                        <span className="text-dark">Mission:</span> {name}
                    </h1>
                    <img className="mt-5 mr-4 mb-4 ml-auto" src={small || LogoSpaceX} alt="Mission Patch" style={{ width: 120 }} />
                </div>

                <h4 className="mb-3">Launch Details</h4>
                <ul className="list-group">
                    <li className="list-group-item opacity-4">
                        Flight Number: {''} {flight_number}
                    </li>
                    <li className="list-group-item opacity-3">
                        Launch Date: {''} <Moment format='YYYY-MM-DD HH:mm'>{date_local}</Moment>
                    </li>
                    <li className="list-group-item opacity-4">
                        Launch Successful: {''}
                        <span
                            className={classNames({
                                'text-success': success,
                                'text-danger': !success
                            })}
                        >
                            {success ? 'Yes' : 'No'}
                            <p className="pt-2">{details}</p>
                        </span>
                    </li>
                </ul>

                <Fragment>
                    <h4 className="my-3">Rocket Details</h4>
                    <div className="list-group-horizontal opacity-4">
                <RocketKey />
                <Fragment> 
                    <RocketItem key={rocket} rocket={objectRocket} />
                </Fragment>
                </div>
                </Fragment>

                <ImageSlider
                    srcArr={objectRocket.flickr_images.concat(objectRocket.flickr_images)}
                />

                <h4 className="my-3">Links</h4>
                <ul className="list-group">
                    <li className="list-group-item text-truncate opacity-4">
                        Presskit: <a target="_blank"
                            rel="noreferrer noopener"
                            href={presskit}
                            title="(open in a new tab)"
                        >
                            &#32;{presskit} </a>
                    </li>
                    <li className="list-group-item text-truncate opacity-5">
                        Article link: <a target="_blank"
                            rel="noreferrer noopener"
                            href={article}
                            title="(open in a new tab)"
                        >
                            &#32;{article} </a>
                    </li>
                    <li className="list-group-item text-truncate opacity-4">
                        Wikipedia: <a target="_blank"
                            rel="noreferrer noopener"
                            href={wikipedia}
                            title="(open in a new tab)"
                        >
                            &#32;{wikipedia} </a>
                    </li>
                    <li className="list-group-item text-truncate opacity-5">
                        Video: <a target="_blank"
                            rel="noreferrer noopener"
                            href={webcast}
                            title="(open in a new tab)"
                            >
                            &#32;{webcast} </a>
                    </li>
                </ul>
            </div>

            <hr />
            <Link to="/" className="list-group-item btn btn-secondary opacity-4">Back</Link>
            <hr />
        </Fragment>
    );
};